import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import reactHtmlParser from 'react-html-parser'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-light-svg-icons'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons'
import Tooltip from '../Tooltip'

// TODO: need to add load/reloading handling. Currently its not adequately implmented
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */

// TODO: Currently the ColorPicker at <LI> & having clickHandlers on these violates A11y
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// The below condition has been deprecated
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */

const Dropdown = (props) => {
  const {
    label,
    inputLabel,
    helpText,
    disabled,
    data: options,
    default: propDefault,
    errorMsg,
    openStatus, // used to tell the parent if the dropdown is open (true) or closed (false)
    style,
  } = props

  const node = useRef()

  const [showList, setShowList] = useState(false)
  const [inputVal, setInputVal] = useState(propDefault || ['', ''])
  const [mistMatchErr, setMistMatchErr] = useState(false)

  // handle clicking outside
  const handleClickOutside = (e) => {
    if (node.current.contains(e.target)) {
      // inside click
      return
    }
    // outside click
    setShowList(false)
  }

  useEffect(() => {
    if (openStatus) openStatus(showList) // pass status to parent component

    if (showList) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    // eslint-disable-next-line
  }, [showList])

  const cleanString = (string) => {
    // the <B> is used in minority cases to bold certain options. Its not needed for this code block
    return string ? string.replace('<B>', '') : string
  }

  const checkDefault = () => {
    const found = options.find((row) => {
      return cleanString(row.name) === cleanString(propDefault[0]) && row.value === propDefault[1]
    })
    return found !== undefined
  }

  useEffect(() => {
    // ensure the default val supplied matches an element in the list
    if (Array.isArray(propDefault) && propDefault[0]) {
      if (checkDefault()) {
        setInputVal(propDefault)
      } else {
        setMistMatchErr(true)
        // eslint-disable-next-line
        console.error(
          'Mismatch Error between default array supplied and list object',
          propDefault,
          options
        )
        // expected to find the default value also in the list object
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    // If the data changes we want to clear the selected value
    if (Array.isArray(propDefault)) {
      if (checkDefault()) {
        setInputVal(propDefault || ['', ''])
      } else {
        setInputVal(['', ''])
      }
    }
    // eslint-disable-next-line
  }, [propDefault])

  const toggleShowList = (e, input) => {
    // hides or shows dropdown list
    const newVal = !showList
    const chevron = input ? input.nextSibling : e.target.nextSibling

    setShowList(newVal)
    // add class to rotate chevron
    chevron.classList.toggle('arrow-up')

    if (props.clickHandler) {
      props.clickHandler(newVal)
    }
  }

  const handleClick = (e) => {
    // set the value of the clicked object to the input field & pass up the tree
    const value = e.target.getAttribute('data-value')
    const name = e.target.getAttribute('data-name')
    const optionalField = e.target.getAttribute('data-optional')
    const input = e.target.closest('div.dropdown-container').querySelector('input[type=text]')

    const formGroupElem = e.target.closest('.form-group')

    toggleShowList(e, input)
    setInputVal([name, value])
    props.action([formGroupElem, [name, value, optionalField]])
  }

  const icon = props.className.indexOf('slim') >= 0 ? faCaretDown : faChevronDown
  const divStyle = { ...style, width: props.width }

  const tooltip = props.tooltip ? (
    <Tooltip
      trigger={props.tooltip.trigger}
      message={props.tooltip.message}
      click={props.tooltip.click}
      position={props.tooltip.position}
      size={props.tooltip.size}
      icon={props.tooltip.icon}
    />
  ) : (
    ''
  )

  let classes = 'form-group'
  classes += errorMsg ? ' error' : ''

  const returnLi = (field, i) => {
    if (field.value === 'OPT_GROUP') {
      return (
        <li className="opt-group" key={`${i}-${field.name}`}>
          {field.name}
        </li>
      )
    }

    let fieldName = field.name || ''
    let htmlName = field.name || ''

    let liStyle = {}
    if (fieldName.includes('<B>')) {
      fieldName = fieldName.replace('<B>', '')
      htmlName = `<b>${fieldName}</b>`
    } else {
      liStyle = { marginLeft: '4px' }
    }

    return (
      <li
        style={liStyle}
        key={`${i}-${fieldName}`}
        data-value={field.value}
        data-name={fieldName}
        data-optional={field.optional}
        onClick={(e) => handleClick(e)}
      >
        {reactHtmlParser(htmlName)}
      </li>
    )
  }

  return (
    <div ref={node} className={classes} style={divStyle}>
      {label && (
        <label className="form-label">
          {label}
          <span>{helpText}</span>
          {tooltip}
        </label>
      )}
      <div className="dropdown-container">
        <span>
          <label>
            {inputLabel ? `${inputLabel} ` : ''}
            <input
              type="text"
              placeholder={props.placeholder}
              value={inputVal ? cleanString(inputVal[0]) : ''}
              data-val={inputVal ? inputVal[1] : ''}
              readOnly
              onClick={disabled ? null : toggleShowList}
              className={props.className}
              name={props.name}
              data-mistmatcherr={mistMatchErr}
              disabled={disabled}
            />
            {disabled && <i className="icon-right far fa-lock" />}
            {!disabled && <FontAwesomeIcon icon={icon} className="arrow-down icon-grey" />}
          </label>
        </span>
        {errorMsg && <p className="error-val">{errorMsg}</p>}
        {showList && (
          <div
            className={`scroll-wrap ${props.className
              .replace('slim', '')
              .replace('invisible', '')}`}
          >
            <div className="list-container">
              <ul className="default-txt">
                {options &&
                  options.map((field, i) => {
                    return returnLi(field, i)
                  })}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

Dropdown.defaultProps = {
  className: '',
  width: '',
  label: '',
  inputLabel: '',
  helpText: '',
  placeholder: '',
  name: '',
  tooltip: null,
  clickHandler: () => {},
  disabled: false,
  errorMsg: null,
  openStatus: false,
  style: {},
}

Dropdown.propTypes = {
  action: PropTypes.func.isRequired,
  default: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  data: PropTypes.array.isRequired,
  clickHandler: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.string,
  label: PropTypes.string,
  inputLabel: PropTypes.string,
  helpText: PropTypes.string,
  tooltip: PropTypes.object,
  disabled: PropTypes.bool,
  errorMsg: PropTypes.string,
  openStatus: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  style: PropTypes.object,
}

export default Dropdown
